import React from 'react';
import axios from 'axios';
import { Switch, Route, Link, Redirect, withRouter } from 'react-router-dom';
import { Breadcrumb, Layout, message, notification } from 'antd';
const { Content, Sider } = Layout;

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import stickyError from 'components/stickyError';
import withSpin from 'components/withSpin';
import AdminSidebar from 'components/AdminSidebar';
import Sidebar from 'components/Sidebar';
import menuItems from './menuItems';
import adminMenuItems from './adminMenuItems';
import calculateBalance from 'components/Portal/FieldPrograms/calculateBalance';

import UserSearchDisplay from 'components/UserSearchDisplay';

import AdminConfig from 'components/Portal/AdminConfig';
import SchoolInformation from 'components/Portal/SchoolInformation';
import Admissions from 'components/Portal/Admissions';
import Personal from 'components/Portal/Personal';
import FieldPrograms from 'components/Portal/FieldPrograms';
import FieldAdmin from 'components/Portal/FieldAdmin';
import Embarkation from 'components/Portal/Embarkation';
import Academic from 'components/Portal/Academic';
import Health from 'components/Portal/Health';
import Travel from 'components/Portal/Travel';
import Agreements from 'components/Portal/Agreements';
import Cabin from 'components/Portal/Cabin';
import Financial from 'components/Portal/Financial';
import Safety from 'components/Portal/Safety';
import AdminRole from 'components/Portal/AdminRole';
//import ViewPrograms from '../../../../portal-components/Portal/FieldAdmin/ViewPrograms';

class Portal extends React.Component {
	state = {
		currentUser: null,
		userRole: [],

		section: null,
		subsection: null,

		folio: {},
		folioLoaded: false,
		folioError: false,

		fieldProgram: {},
		fieldProgramLoaded: false,
		fieldProgramError: false,

		booking: {},
		bookingLoaded: false,
		bookingError: false,

		bookedItems: [],

		transactions: [],
		transactionsLoaded: false,
		chargeTotal: null,
		creditTotal: null,
		fieldTransactions: [],
		fieldPayments: [],
		tuitionTransactions: [],
		tuitionPayments: [],
		insuranceTransactions: [],
		insuranceChargeTotal: null,
		insurancePayments: [],
		insuranceCreditTotal: null,

		statuses: null,
		statusesLoaded: false,

		agency: null,
		agencyLoaded: false,
		agencyError: false,

		GSCneeded: true,
		GSCused: false,

		isStudent: null,
		isStaff: null,
		isFaculty: null,
		isGapOrPost: null,
		isWaitList: null,

		actionPlan: null,
		gpa: [],
		canSeeBiogaphy: false,
		gapNote: [],

		voyages: [],
	}
	kickSession = () => {
		this.props.history.push('/');
	}

	getGpa = () => {
		axios.get(apiPath + '/admissions/getGpa', { withCredentials: true }).then(result => {
			this.setState({ gpa: result.data })
		})
	}

	getActionPlan = () => {
		axios.get(apiPath + '/admissions/getActionPlan', { withCredentials: true }).then(result => {
			this.setState({ actionPlan: result.data })
		})
	}
	handleUserChange = (user) => {
		this.props.isLoading();
		this.setState({
			bookingLoaded: false,
			agencyLoaded: false,
			remarksLoaded: false,
			statusesLoaded: false
		});
		if (user !== null) {
			axios.post(apiPath + '/login', {
				RepeaterNo: user.folRepeaterNo
			}, {
					withCredentials: true
				}).then(response => {
					this.setState({ currentUser: user });
					localStorage.setItem('currentUser', JSON.stringify(user));
					this.loadFolio().then(result => {
						//this.oldLoadBooking();
						this.loadBooking();
						this.loadAgency();
						this.loadRemarks();
						this.loadStatuses();
						this.getGapNote();
						this.checkIfWaitlist();
						this.props.isDoneLoading();
						this.getActionPlan();
					}).catch(error => {
						this.props.isDoneLoading();
						console.error(error);
					});
				}).catch(error => {
					this.props.isDoneLoading();
					console.error(error);
					if (error.response.status === 401) {
						this.kickSession();
						stickyError('Your session has timed out');
						this.props.history.push('/');
					} else {
						console.error(error);
						stickyError('Login failed: ' + error.message, 0, true);
					}
					localStorage.setItem('redirectAfterLogin', window.location.hash);
					localStorage.setItem('currentUser', JSON.stringify(null));
					this.setState({ folioError: true, currentUser: null });
				});
		} else {
			axios.get(apiPath + '/clearlogin', { withCredentials: true }).then(result => {
				this.setState({ currentUser: null, isWaitList: null });
				localStorage.setItem('currentUser', JSON.stringify(null));
				this.props.isDoneLoading();
			}).catch(console.error);
		}
	}
	handleStatusChange = (event, statusType) => {
		const update = {};
		update[statusType] = event.target.value;
		axios.put(apiPath + '/statuses', update, { withCredentials: true }).then(result => {
			message.success('Updated');
			this.loadStatuses();
		}).catch(error => {
			stickyError(error.message);
			console.error(error);
		});
	}
	loadFieldClasses = () => {
		axios.get(apiPath + '/fieldclasses', { withCredentials: true }).then(result => {
			if (result.data && result.data.Item) localStorage.setItem('fieldClasses', JSON.stringify(result.data.Item));
			else stickyError('Failed to load field class data');
		}).catch(error => {
			if (!localStorage.fieldClasses || localStorage.fieldClasses.length < 5) {
				return this.handleAxiosLoadError(error);
			}
		});
	}
	loadFolio = () => {
		return axios.get(apiPath + '/folio', { withCredentials: true }).then(response => {
			this.setState({
				folioLoaded: true,
				folio: response.data
			});
		});
	}
	updateFolio = (form, subsection) => {
		return new Promise((resolve, reject) => {
			form.validateFields((errors, values) => {
				if (values.BirthDate) {
					values.BirthDate = moment(values.BirthDate).format('YYYY-MM-DDT00:00:00');
				}
				if (errors) {
					const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
					stickyError('Validation error: ' + firstErrorMessage, 4.5);
					reject(errors);
				}
				else {
					let update = {};
					switch (subsection) {
						case 'DocumentList':
							const Nationality = values.Nationality;
							delete values.Nationality;
							delete values.copy;
							delete values.photo;
							const BirthDate = values.BirthDate;
							delete values.BirthDate
							values.IssueDate = moment(values.IssueDate).format('YYYY-MM-DDT00:00:00');
							values.ExpiryDate = moment(values.ExpiryDate).format('YYYY-MM-DDT00:00:00');
							update = { DocumentList: { Document: values } };
							if (BirthDate !== null) {
								update.BirthDate = BirthDate
							}
							if (Nationality) update.Nationality = Nationality;
							break;
						case 'Emergency':
							update = { Emergency: values };
							break;
						case 'Visas':
							update = {
								DocumentList: Object.keys(values)
									.filter(key => key.substring(0, 10) !== 'DocumentId')
									.filter(key => { return values[key]; })
									.map(key => {
										let doc = {
											Type: 'V',
											IssueCountry: key,
											No: 'none',
											ExpiryDate: values[key]
										};
										if (values['DocumentId_' + key])
											doc.DocumentId = values['DocumentId_' + key];
										else doc.ExternalId = key + moment().format('x');
										return doc;
									})
							};
							break;
						default:
							update = values;
							break;
					}
					axios.put(apiPath + '/folio', update, { withCredentials: true }).then(response => {
						message.success('Saved!');
						const newFolio = Object.assign(this.state.folio, update);
						this.setState({ folio: newFolio });
						resolve(newFolio);
					}).catch(error => {
						// stickyError(error.message, 0, true);
						reject(error);
					});
				}
			});
		});
	}
	loadFieldProgram = () => {
		this.setState({ fieldProgramLoaded: false });
		return axios.get(apiPath + '/fieldAdmin/getFieldPrograms', { withCredentials: true }).then(response => {
			if (!response.data) {
				return stickyError('Error loading Field Program', 0, true);
			}
			this.setState({
				fieldProgram: response.data.items,
				fieldProgramLoaded: true
			});
		}).catch(error => {
			this.setState({ transactionsError: error });
		});
	}
	addFieldProgram = (data) => {
		return axios.post(apiPath + '/addFieldProgram', data, { withCredentials: true }).then(response => {
			if (!response.data) {
				return stickyError('Error adding field program', 0, true);
			}
			this.setState({
				fieldProgram: response.data.items
			});
		}).catch(error => {
			this.setState({ transactionsError: error });
		});
	}
	updateFieldProgram = (data) => {
		return axios.post(apiPath + '/updateFieldProgram', data, { withCredentials: true }).then(response => {
			if (!response.data) {
				return stickyError('Error updating field program', 0, true);
			}
			this.setState({
				fieldProgram: response.data.items
			});
		}).catch(error => {
			this.setState({ transactionsError: error });
		});
	}
	removeFieldProgram = (data) => {
		return axios.delete(apiPath + '/removeFieldProgram', data, { withCredentials: true }).then(response => {
			if (!response.data) {
				return stickyError('Error removing field program', 0, true);
			}
			this.setState({
				fieldProgram: response.data.items
			});
		}).catch(error => {
			this.setState({ transactionsError: error });
		});
	}
	loadBooking = () => {
		this.setState({ bookingLoaded: false });
		return axios.get(apiPath + '/booking', { withCredentials: true }).then(response => {
			if (!response.data) {
				return stickyError('Error loading booking', 0, true);
			}
			this.setState({
				bookedItems: response.data.items,
				booking: {
					BookingId: response.data.BookingId,
					EventId: response.data.EventId,
					BookingCode: response.data.BookingCode
				},
				bookingLoaded: true,
				bookingError: false,
				GSCused: response.data.items && response.data.items.find(item => item.Comments.indexOf('GSCE - DO NOT CHARGE') !== -1)
			});
			this.checkIfStudent();
			this.checkIfWaitlist();
			calculateBalance(response, this.kickSession).then(result => {
				this.setState({
					transactions: result.transactions,
					transactionsLoaded: true,
					transactionsError: false,
					fieldChargeTotal: result.fieldChargeTotal,
					fieldCreditTotal: result.fieldCreditTotal,
					tuitionChargeTotal: result.tuitionChargeTotal,
					tuitionCreditTotal: result.tuitionCreditTotal,
					fieldTransactions: result.fieldTransactions,
					fieldPayments: result.fieldPayments,
					tuitionTransactions: result.tuitionTransactions,
					tuitionPayments: result.tuitionPayments,
					insuranceTransactions: result.insuranceTransactions,
					insuranceChargeTotal: result.insuranceChargeTotal,
					insurancePayments: result.insurancePayments,
					insuranceCreditTotal: result.insuranceCreditTotal
				})
			}).catch(error => {
				this.setState({ transactionsError: error });
			});
			return response.data.items;
		});
	}
	loadAgency = () => {
		axios.get(apiPath + '/agency', { withCredentials: true }).then(result => {
			this.setState({
				agency: result.data,
				isStaff: result.data.Name === 'Staff',
				isFaculty: result.data.Name === 'Faculty',
				isGapOrPost: result.data.Name === 'GAP' || result.data.Name === 'Post-Graduate',
				isLLL: result.data.Name === 'Life Long Learner' || result.data.Name === 'Lifelong Learner',
				agencyLoaded: true,
				agencyError: false
			});
		});
	}
	loadRemarks = () => {
		return axios.get(apiPath + '/remarks', { withCredentials: true }).then(response => {
			this.setState({
				remarks: response.data,
				remarksLoaded: true,
				remarksError: false
			});
		})
	}
	loadStatuses = () => {
		return axios.get(apiPath + '/statuses', { withCredentials: true }).then(response => {
			this.setState({
				statuses: response.data,
				statusesLoaded: true
			});
		});
	}
	updateStatuses = (form, trueValue, falseValue) => {
		return new Promise((resolve, reject) => {
			form.validateFields((errors, values) => {
				if (errors) {
					const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
					stickyError('Validation error: ' + firstErrorMessage, 4.5);
					reject(errors);
				}
				else {
					if (trueValue) {
						for (let v in values) {
							if (v.indexOf('SRI_') === -1) delete values[v];
							else values[v] = (values[v]) ? trueValue : falseValue;
						}
					}
					for (let v in values) {
						if (['SRI_YELLOW_FEVER_VAC'].indexOf(v) !== -1) { // dates
							values[v] = values[v].format('YYYY-MM-DD');
						}
					}
					axios.put(apiPath + '/statuses', values, { withCredentials: true }).then(response => {
						notification.success({ message: 'Saved!' });
						const newStatuses = Object.assign(this.state.statuses, values);
						this.setState({ statuses: newStatuses });
						resolve(newStatuses);
					}).catch(error => {
						this.handleAxiosSaveError(error);
						reject(error);
					});
				}
			});
		});
	}
	checkIfStudent = () => {
		axios.get(apiPath + '/isstudent', { withCredentials: true }).then(response => {
			this.setState({
				isStudent: response.data,
				GSCneeded: response.data
			});
		}).catch(error => {
			console.error(error);
			stickyError(error.message, 0, true);
			this.setState({ bookingError: true });
		});
	}
	checkIfWaitlist = () => {
		axios.get(apiPath+'/iswaitlist', {withCredentials: true}).then(response => {
			this.setState({
				isWaitList: response.data
			});
		});
	}
	updateSections = (props) => {
		this.setState({
			section: props.location.pathname.split('/')[2],
			subsection: props.location.pathname.split('/')[3]
		});
	}
	//Get admin email
	getAdminEmail = () => {
		axios.get(apiPath + '/getAdmin', { withCredentials: true }).then(result => {
			if (result.data === 'jzaksek@isevoyages.org') {
				this.setState({ canSeeBiogaphy: true })
			}
		})
	}

	//Get GAP Note
	getGapNote = () => {
		axios.get(apiPath + '/note/getGapNote', { withCredentials: true }).then(result => {
			this.setState({ gapNote: result.data })
		})
	}

	getUserRole = () => {
		axios.get(apiPath + '/adminRole/getUserRole', { withCredentials: true }).then(result => {
			if(result.data !== undefined){
			this.setState({userRole: result.data})
			}
		})
	}

	getVoyages = async () => {
		try {
			const response = await fetch(
				`${apiPath}/voyages?pastEvents=1`,
			)

			if (!response.ok) {
				throw new Error(response.statusText)
			}

			const voyages = await response.json()

			this.setState({ voyages })
		} catch (error) {
			console.error(error)
		}
	}

	componentWillReceiveProps(nextProps) { this.updateSections(nextProps); }
	componentWillMount() { this.updateSections(this.props); }
	componentDidMount() {
		notification.destroy();

		if (this.state.currentUser === null && typeof localStorage.currentUser !== 'undefined' && JSON.parse(localStorage.currentUser) !== null) {
			this.handleUserChange(JSON.parse(localStorage.currentUser));
		}

		this.loadFieldClasses();
		this.loadBooking();
		this.loadFieldProgram();
		this.getActionPlan();
		this.getAdminEmail();
		this.getGapNote();
		this.getUserRole();
		this.getVoyages();
	}
	render() {
		let routeProps = {
			variant: 'admin',

			folio: this.state.folio,
			folioLoaded: this.state.folioLoaded,
			folioError: this.state.folioError,
			updateFolio: this.updateFolio,
			refreshFolio: this.loadFolio,

			fieldProgram: this.state.fieldProgram,
			fieldProgramLoaded: this.state.fieldProgramLoaded,
			fieldProgramError: this.state.fieldProgramError,
			addFieldProgram: this.addFieldProgram,
			updateFieldProgram: this.updateFieldProgram,
			removeFieldProgram: this.removeFieldProgram,

			booking: this.state.booking,
			bookingLoaded: this.state.bookingLoaded,
			bookingError: this.state.bookingError,
			bookedItems: this.state.bookedItems,
			// bookedItemsLoaded: this.state.bookingLoaded,
			// bookedItemsError: this.state.bookedItemsError,
			bookingHasShuttle: this.state.bookingHasShuttle,
			// refreshBookedItems: this.loadBookedItems,
			refreshBooking: this.loadBooking,

			transactions: this.state.transactions,
			transactionsLoaded: this.state.transactionsLoaded,
			transactionsError: this.state.transactionsError,
			fieldChargeTotal: this.state.fieldChargeTotal,
			fieldCreditTotal: this.state.fieldCreditTotal,
			tuitionChargeTotal: this.state.tuitionChargeTotal,
			tuitionCreditTotal: this.state.tuitionCreditTotal,
			fieldTransactions: this.state.fieldTransactions,
			fieldPayments: this.state.fieldPayments,
			tuitionTransactions: this.state.tuitionTransactions,
			tuitionPayments: this.state.tuitionPayments,
			insuranceTransactions: this.state.insuranceTransactions,
			insuranceChargeTotal: this.state.insuranceChargeTotal,
			insurancePayments: this.state.insurancePayments,
			insuranceCreditTotal: this.state.insuranceCreditTotal,

			remarks: this.state.remarks,
			remarksLoaded: this.state.remarksLoaded,
			remarksError: this.state.remarksError,
			refreshRemarks: this.loadRemarks,

			statuses: this.state.statuses,
			statusesLoaded: this.state.statusesLoaded,
			updateStatuses: this.updateStatuses,
			refreshStatuses: this.loadStatuses,

			agency: this.state.agency,
			agencyLoaded: this.state.agencyLoaded,
			agencyError: this.state.agencyError,

			GSCused: this.state.GSCused,
			GSCneeded: this.state.GSCneeded,
			isStudent: this.state.isStudent,
			isStaff: this.state.isStaff,
			isFaculty: this.state.isFaculty,
			isGapOrPost: this.state.isGapOrPost,
			isLLL: this.state.isLLL,
			isWaitList: this.state.isWaitList,
			kickSession: this.kickSession,
			academicActionStatus: this.state.actionPlan && this.state.actionPlan.Status,
			getActionPlan: this.getActionPlan,
			canSeeBiography: this.state.canSeeBiogaphy,
			gapNote: this.state.gapNote,
			userRole: this.state.userRole === undefined ? '' : this.state.userRole,

			handleStatusChange: this.handleStatusChange
		};
		const activeSection = menuItems(routeProps).find(item => { return item.key.toLowerCase() === this.state.section });
		return (
			<Layout>
				{this.state.folioError && <Redirect to="/" />}

				<Sider breakpoint="sm" width="250" collapsedWidth="0">
					<Switch>
						<Route path="/portal/fieldadmin" render={() => (
							<AdminSidebar
								menuItems={adminMenuItems(routeProps)}
								fieldProgram={this.state.fieldProgram}/>
							)} />
						<Route path="*" render={() => (
							<Sidebar
								voyages={this.state.voyages}
								menuItems={menuItems(routeProps)}
								GSCused={this.state.GSCused}
								GSCneeded={this.state.GSCneeded}
								booking={this.state.booking}
								refreshBooking={this.loadBooking}
								refreshStatuses={this.loadStatuses}/>
							)}
						/>
					</Switch>
				</Sider>

				<Content>
					<Switch>
						<Route path="/portal/config" component={() => <AdminConfig voyages={this.state.voyages} />} />
						<Route path="/portal/school" render={() => <SchoolInformation {...routeProps} />} />
						<Route path="/portal/AdminRole" component={AdminRole} />
						<Route path="/portal/fieldadmin" render={() => <FieldAdmin {...routeProps} />} />
						<Route path="*" render={() => (
							<div>
								<UserSearchDisplay
									voyages={this.state.voyages}
									kickSession={this.kickSession}
									currentUser={this.state.currentUser}
									onUserChange={this.handleUserChange} />

								<div style={{ padding: '8pt' }}>
									<Breadcrumb>
										{activeSection && <Breadcrumb.Item><Link to="/portal">Portal</Link></Breadcrumb.Item>}
										{activeSection && <Breadcrumb.Item><Link to={'/portal/' + this.state.section}>{activeSection.titleText}</Link></Breadcrumb.Item>}
										<Breadcrumb.Item>{this.state.subsection}</Breadcrumb.Item>
									</Breadcrumb>
								</div>

								{this.state.currentUser === null &&
									<h3 style={{ padding: '8pt' }}>Please select a user using the search boxes above</h3>
								}

								{this.state.currentUser !== null &&
									<div>
										{(this.state.subsection || (activeSection && activeSection.titleText)) &&
											<h1 style={{ margin: '8pt 32pt' }}>
												{this.state.subsection || activeSection.titleText}
											</h1>
										}

										<div style={{ padding: '16pt 32pt' }}>
											<Switch>
												<Route path="/portal/safety" render={() => <Safety {...routeProps} />} />
												<Route path="/portal/personal" render={() => <Personal {...routeProps} />} />
												<Route path="/portal/admissions" render={() => <Admissions {...routeProps} />} />
												<Route path="/portal/field" render={() => <FieldPrograms {...routeProps} />} />
												<Route path="/portal/travel" render={() => <Travel {...routeProps} />} />
												<Route path="/portal/embarkation" render={() => <Embarkation {...routeProps} />} />
												<Route path="/portal/health" render={() => <Health {...routeProps} />} />
												<Route path="/portal/academic" render={() => <Academic {...routeProps} />} />
												<Route path="/portal/agreements" render={() => <Agreements {...routeProps} />} />
												<Route path="/portal/financial" render={() => <Financial {...routeProps} />} />
												<Route path="/portal/cabin" render={() => <Cabin {...routeProps} />} />
												<Route path="*" render={() => (
													<Redirect to="/portal/personal" />
												)} />
											</Switch>
										</div>
									</div>
								}
							</div>
						)} />
					</Switch>
				</Content>
			</Layout>
		);
	}
}

export default withRouter(withSpin(Portal));



// WEBPACK FOOTER //
// ./src/containers/Portal/index.jsx